export default function CvTrainingItem({ training }) {
  const year = String(training.endDate || training.startDate || '').slice(0, 4);
  const duration = training.durationHours ? `${training.durationHours} h` : training.durationDays ? `${training.durationDays} j` : '';
  return <article className="cv-education cv-training"><strong className="cv-education__title">{training.title}</strong><span className="cv-education__meta">{[training.provider, year, duration].filter(Boolean).join(' · ')}</span></article>;
}
